import planning from "../../Assets/Images/serv_planning.png";
import hotel from "../../Assets/Images/serv_hotel.png";
import travel from "../../Assets/Images/serv_travel.png";
import market from "../../Assets/Images/serv_market.png";
import creative from "../../Assets/Images/serv_creative.png";
import stage from "../../Assets/Images/serv_stage.png";
import website from "../../Assets/Images/serv_website.png";
import manage from "../../Assets/Images/serv_manage.png";
import sponsership from "../../Assets/Images/serv_sponsership.png";
import gift from "../../Assets/Images/serv_gift.png";

const services = [
  {
    title: "Event Planning & Execution",
    description:
      "Creating unique themed events and destination experiences. From ideation to execution, we ensure every moment of your event has precision, creativity, and flawless execution.",
    image: planning,
    imageLeft: true,
  },
  {
    title: "Hotel & Venue Selection",
    description:
      "We help you find the perfect venue and accommodations, ensuring comfort, convenience, and suitability for your event.",
    image: hotel,
    imageLeft: false,
  },
  {
    title: "Travel & Logistics",
    description:
      "From flight bookings to ground transportation, we plan and manage travel and accommodation arrangements for your guests and speakers.",
    image: travel,
    imageLeft: true,
  },
  {
    title: "Marketing & Promotions",
    description:
      "We create and implement strategic marketing campaigns to optimize visibility, audience engagement, and ticket sales.",
    image: market,
    imageLeft: false,
  },
  {
    title: "Creative Designing",
    description:
      "Our team crafts stunning visuals, branding collateral, and digital assets tailored to your event’s appeal.",
    image: creative,
    imageLeft: true,
  },
  {
    title: "Stage & AV Setup",
    description:
      "From audio to live lighting, music to screens, we bring your event to life with seamless stage and technical setup.",
    image: stage,
    imageLeft: false,
  },
  {
    title: "Event Website & Digital Solutions",
    description:
      "We provide top-tier lighting, sound, LED screens, and stage production for a visually and acoustically flawless event experience.",
    image: website,
    imageLeft: true,
  },
  {
    title: "Entertainment & Artist Management",
    description:
      "We connect you with renowned speakers, celebrities, and performers to elevate your event’s entertainment quotient.",
    image: manage,
    imageLeft: false,
  },
  {
    title: "Sponsorship & Partnership Management",
    description:
      "We secure valuable sponsorships and manage strategic partnerships to enhance your event’s success and outreach.",
    image: sponsership,
    imageLeft: true,
  },
  {
    title: "Corporate Gifting & Merchandise",
    description:
      "We curate customized giveaways, souvenirs, and branding merchandise to leave a lasting impression on your attendees.",
    image: gift,
    imageLeft: false,
  },
];

const ServiceContent = () => {
  return (
    <section className="pt-0">
      <div className="container-fluid serv-content">
        {services.map((service, index) => (
          <div
            className="row align-items-center justify-content-between  p-0"
            key={index}>
            <div
              className={`col-md-6 col-lg-6  mb-3 mb-md-0 p-md-0 ${
                service.imageLeft ? "" : "order-md-2"
              }`}>
              <img
                src={service.image}
                alt={service.title}
                className="img-fluid "
              />
            </div>
            <div
              className={`col-md-6 col-lg-5 px-md-3 p-xl-5 ${
                service.imageLeft ? "" : "order-md-1"
              } text-md-center text-start`}>
              <h2 className="pb-4">{service.title}</h2>
              <p>{service.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ServiceContent;
